import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const Suspense = ({ children, fallback, loading }) => {
    if (loading)
        return _jsx(_Fragment, { children: fallback });
    return _jsx(_Fragment, { children: children });
};
